
import { computed, defineComponent, ref } from "vue";
export default defineComponent({
  name: "ImageLoader",
  props: {
    src: {
      type: String,
      required: true,
    },
    ipfs: {
      type: Boolean,
      required: false,
    },
    width: {
      type: Number,
      required: false,
    },
    height: {
      type: Number,
      required: false,
    },
  },

  setup(props) {
    const loaded = ref(false);
    const dataUrl = computed(
      () =>
        `data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg"
        width="${props.width ?? 500}" height="${props.height ?? 500}"></svg>`
    );
    return { loaded, dataUrl };
  },
});
